import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Components
import dataHandler from "@Utils/dataHandler";
import Screen from "@Components/Screen";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

// Modal
import ConfirmModal from "@Modals/ConfirmModal";
import IkTable from "@Components/IkTable";
import ContactGroupsCrud from "./Modals/ContactGroupsCrud";

// Styles
import styles from "./styles.module.css";

const ContactGroups = ({ dispatch, userName, companyName }) => {
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [openContactoCrud, setOpenContactoCrud] = useState(false);
	const [tableValue, setTableValue] = useState([]);
	const [contactData, setContactData] = useState([]);
	const [contactDataAll, setContactDataAll] = useState([]);

	const [filteredItems, setFilteredItems] = useState([]);
	const [modalOption, setModalOption] = useState([]);
	const [filteredCount, setfilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);

	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc" };

	useEffect(() => {
		(async () => {
			const contactGroupsPromise = dataHandler({
				dispatch,
				url: "contactgroups",
				params: defaultParams,
			});

			const contactPromise = dataHandler({
				dispatch,
				url: "contacts",
				params: { page: 1, orderKey: "contactId", orderDir: "desc" },
			});

			const contactGroupsAllPromise = dispatch(genericAction({ method: "get", route: "contactgroups/all" }));

			const [contactGroupsResponse, contactResponse, contactGroupsAllResponse] = await Promise.all([
				contactGroupsPromise,
				contactPromise,
				contactGroupsAllPromise,
			]);

			setFilteredItems(contactGroupsResponse.items);
			setfilteredCount(contactGroupsResponse.count);
			setContactData(contactResponse);
			setContactDataAll(contactGroupsAllResponse);
		})();
	}, []);

	const modalData = (name, item) => {
		setModalOption(name);
		setOpenContactoCrud(true);
		setTableValue(item);
	};

	const apiData = async (name) => {
		switch (name) {
			case "Edit":
				setOpenContactoCrud(false);
				break;

			case "Eraser":
				setOpenConfirmModal(false);
				await dispatch(genericAction({ method: "delete", route: `contactgroups/${tableValue.id}` }));
				break;
			default:
				break;
		}
		const contactGroupsResponse = await dataHandler({
			dispatch,
			url: "contactgroups",
			params: defaultParams,
		});

		setfilteredCount(contactGroupsResponse.count);
		setFilteredItems(contactGroupsResponse.items);
	};

	// Table handlers
	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};
	// Table handlers
	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "contactgroups", params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setfilteredCount(data.count);
		}
	};

	return (
		<Screen hasSidebar hasHeader headerTitle="Grupo Contactos">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<IkTable
						data={filteredItems}
						columns={[
							{
								label: "Acciones",
								action: [
									{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
									{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
								],
								dataPosition: "center",
								width: 1,
								canFilter: false,
								canSort: false,
							},
							{
								label: "ID",
								key: "id",
								format: "string",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "Nombre",
								key: "name",
								format: "string",
								width: 5,
							},
							{
								label: "contactList",
								format: "arrayTruncate",
								hidden: true,
								key: "restriction",
								width: 2,
							},
						]}
						print={{
							printHeader: { company: companyName, title: "Grupos Contactos", user: userName },
						}}
						totalRows={filteredCount}
						filteredPrintData={filteredPrintData}
						defaultParams={defaultParams}
						dataHandler={handlerData}
						handlerTable={handleButtom}
						addButton={{ label: "Agregar" }}
					/>
				</div>
			</div>
			{openContactoCrud && (
				<ContactGroupsCrud
					contactData={contactData}
					apiData={apiData}
					tableValue={tableValue}
					contactDataAll={contactDataAll}
					onClose={() => {
						setOpenContactoCrud(false);
					}}
					modalCrud={modalOption}
				/>
			)}
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					buttonLabel="Eliminar"
					header="Confirmar"
					content="Está seguro que desea eliminar la categoría"
					focus={tableValue.name}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						setOpenConfirmModal(false);
					}}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		companyName: company.name,
		userName: user.name,
	};
}

ContactGroups.propTypes = {
	dispatch: PropTypes.func,
	companyName: PropTypes.string,
	userName: PropTypes.string,
};

export default connect(mapStateToProps)(ContactGroups);
